import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import AddFormModal from './Component/AddFormModal';
import EventItemList from './Component/ItemList';
import LocationOption from '../../../_components/Options/LocationOption'
import EventTypeOption from '../../../_components/Options/EventTypeOption'
import ReactDatePicker from '../../../_components/DatePicker/ReactDatePicker'
import ProfessionalOption from '../../../_components/Options/ProfessionalOption';
import AddTelehealthModal from './Component/AddTelehealthModal';
import RenderValidateMessage from '../../../stories/Validation/RenderValidateMessage';

import { Dropdown } from 'react-bootstrap';
import { Component } from 'react';

import "react-datepicker/dist/react-datepicker.css";

const CURRENT_STEP = 'EVENT_DETAILS';

class EventDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      showAddFormModal: false,
      showAddTelehealthModal: false,
    }
    this.validate = this.validate.bind(this);
  }

  validate(e) {
    e.preventDefault();

    const {
      group,
      provider,
      eventType,
      date,
      time,
      eventItems,
    } = this.props;

    let errors = {};

    if (eventItems.length === 0) {
      errors.eventItems = 'No Event Items.'
    }

    if (!eventType.value) {
      errors.eventType = 'Event type is required.';
    }

    if (!date) {
      errors.date = 'Event Date is required.'
    } else if (moment(moment(date).format('YYYY-MM-DD')).isBefore(moment(new Date()).format('YYYY-MM-DD'))) {
      errors.date = 'Event Date must be upcoming.';
    }

    if (!group.value) {
      errors.group = 'Location is required.';
    }

    if (!provider.value) {
      errors.provider = 'Provider is required.';
    }

    this.setState({ errors });

    if (!errors.date && !errors.provider && !errors.eventItems && !errors.group) {
      this.props.saveEvent();
    }
  }

  render() {
    if (this.props.currentStep !== CURRENT_STEP) {
      return null;
    }

    const {
      group,
      provider,
      setValue,
      isSaving,
      date,
      time,
      eventType,
      eventItems,
      addEventItem,
      rescheduleEventItem,
    } = this.props;

    return (
      <div className="card axs-shadow">
        <div className="card-body">
          <h3>Schedule Event</h3>
          <hr />

          {this.props.eventItems.length === 0 &&
            ('eventItems' in this.state.errors) &&
            <div className="alert alert-danger my-4" role="alert">
              Please add an event item below.
            </div>
          }

          <h6>Event Details</h6>

          <form className="mt-4">
            <div className="form-group mb-4">
              <div className="row">
                <div className="col-sm-3">
                  <label><span className="text-danger">*</span> Event Type</label>
                  <EventTypeOption defaultValue={eventType.value} handleSelected={(value, label) => setValue('eventType', { value: value, label: label })} />
                  <RenderValidateMessage errors={this.state.errors} field="eventType" />
                </div>
                <div className="col-sm-3">
                  <div className="row">
                    <div className="col-6">
                      <label><span className="text-danger">*</span> Event Date</label>
                      <ReactDatePicker
                        selected={date}
                        onChange={(date) => setValue('date', date)}
                        minDate={new Date()}
                        dateFormat="M/dd/yyyy"
                        className="form-control"
                        wrapperClassName="w-100"
                      />
                      <RenderValidateMessage errors={this.state.errors} field="date" />
                    </div>
                    <div className="col-6">
                      <label>Event Time</label>
                      <DatePicker
                        selected={time}
                        onChange={(time) => setValue('time', time)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        className="form-control"
                        dateFormat="h:mm aa"
                        wrapperClassName="w-100"
                      />
                      <RenderValidateMessage errors={this.state.errors} field="time" />
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <label><span className="text-danger">*</span> Treating Provider</label>
                  <ProfessionalOption defaultValue={provider.value} handleSelected={(value, label) => setValue('provider', { value: value, label: label })} />
                  <RenderValidateMessage errors={this.state.errors} field="provider" />
                </div>
                <div className="col-sm-3">
                  <label><span className="text-danger">*</span> Location</label>
                  <LocationOption defaultValue={group.value} handleSelected={(value, label) => setValue('group', { value: value, label: label })} />
                  <RenderValidateMessage errors={this.state.errors} field="group" />
                </div>
              </div>
            </div>

            <AddFormModal
              show={this.state.showAddFormModal}
              hide={() => this.setState({ showAddFormModal: false })}
              setValue={setValue}
              groupSelected={group}
              addEventItem={addEventItem}
              completeByDate={date}
              providerSelected={provider}
            />

            <AddTelehealthModal
              show={this.state.showAddTelehealthModal}
              hide={() => this.setState({ showAddTelehealthModal: false })}
              setValue={setValue}
              groupSelected={group}
              addEventItem={addEventItem}
              appointmentDate={date}
              providerSelected={provider}
            />

            <EventItemList
              setValue={setValue}
              eventItems={eventItems}
              rescheduleEventItem={rescheduleEventItem}
            />

            <br />

            <Dropdown className="text-right mt-3">
              <Dropdown.Toggle className="px-4" id="dropdown-custom-components">Add Event</Dropdown.Toggle>

              <Dropdown.Menu align="right">
                <Dropdown.Item eventKey="1" className="pr-5 py-2" onClick={() => this.setState({ showAddFormModal: true })}>Add Form</Dropdown.Item>
                <Dropdown.Item eventKey="2" className="pr-5 py-2" onClick={() => this.setState({ showAddTelehealthModal: true })}>Add Telehealth</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <br />
          </form>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-sm-2">
              <button
                disabled={isSaving}
                onClick={this.props.backStep}
                type="submit" className="btn btn-outline-primary btn-block">Back</button>
            </div>
            <div className="col-sm-4">
              <button
                onClick={this.validate}
                disabled={isSaving}
                type="submit" className="btn btn-primary btn-block">
                {isSaving ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Schedule Event'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EventDetails;